import http from './http.service';
import { useUserStore } from '../stores/UserStore';

export class UserService {

  signup(data) {
    return http.post('/signup', data)
      .then(response => {
        const userStore = useUserStore();
        userStore.user = response.data.data;
      });
  }

  update(data) {
    return http.put('/update', data)
      .then(response => {
        const userStore = useUserStore();
        userStore.user = response.data.data;
      });
  }

  signupVendor(data) {
    return http.post('/signupvendor', data)
      .then(response => {
        const userStore = useUserStore();
        userStore.user = response.data.user;
      });
  }

  requestResetPassword(data) {
    return http.post('/requestresetpassword', data)
      .then(response => response.data);
  }

  resetPassword(data) {
    return http.post('/resetpassword', data)
      .then(response => response.data);
  }

  login(data) {
    return http.post('/login', data)
      .then((response) => {
        return response.data.data;
      })
      .catch(() => { return null; })
  }
  
  logout() {
    return http.post('/logout').catch(() => {})
  }

  setAcceptLicense() {
    return http.put('/acceptlicense')
  }

  getVendorStatistics() {
    const userStore = useUserStore()
    const companyId = userStore.selectedCompany.id;

    return http.get(`/vendor/${companyId}/statistics`)
      .then(response => response.data);
  }

  verifyLogin() {
    return http.get('/details')
      .then(response => {
        return response.data.data;
      })
      .catch(() => { 
        return null;
      });
  }
}
